var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.path !== undefined)?_c('div',{staticClass:"linear"},[_c('router-link',{attrs:{"to":_vm.path}},[_vm._v(_vm._s(_vm.name)),_c('ArrowButton')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }